module.exports = __webpack_public_path__ + "static/media/Arrow_Long_Right_Blur.0a738847.svg";